export default __webpack_public_path__ + "static/media/Guru-Parampara-16.29afdfa0.png";